/* ============================================================
ELIXA QUIZ FUNNEL — JavaScript Engine
v8 → Shopify conversion
Configuration is injected by the Liquid section via
window.ELIXA_CONFIG before this script runs.
============================================================ */
(function () {
'use strict';
/* ----------------------------------------------------------
CONFIG — injected by section liquid via window.ELIXA_CONFIG
Falls back to safe defaults if not set.
---------------------------------------------------------- */
var CFG = window.ELIXA_CONFIG || {};
var WEBHOOK_URL = CFG.webhook_url || '';
var CTA_URL = CFG.cta_url || '/';
var CTA_SAME_TAB = CFG.cta_same_tab || false;
var APPEND_PARAMS = CFG.append_params !== false; /* default true */
var LOADING_MS = (CFG.loading_seconds || 5.5) * 1000;
var USE_FIRST_NAME = CFG.use_first_name !== false; /* default true */
var FALLBACK_HEADLINE = CFG.fallback_headline || 'Your results are in';
var PROOF_COPY = CFG.proof_copy || 'Chris, B and <b>2,150+</b> other Elixa users have got results with a similar skin profile as yours.';
var SHOW_PROOF = CFG.show_proof !== false;
var SHOW_TIMER = CFG.show_timer !== false;
var TIMER_LABEL = CFG.timer_label || 'Offer reserved for';
var TIMER_MINUTES = CFG.timer_minutes != null ? parseInt(CFG.timer_minutes) : 4;
var TIMER_SECONDS = CFG.timer_seconds != null ? parseInt(CFG.timer_seconds) : 23;
var BENEFIT_LINE = CFG.benefit_line || 'For acne scars and uneven texture';
var DYNAMIC_BENEFIT = CFG.dynamic_benefit !== false;
var OFFER_LINE = CFG.offer_line || 'Exclusive Offer: 40% off first 2 months';
var PRODUCT_NAME = CFG.product_name || 'PDRN Micro-Infusion Skin Booster';
var CTA_TEXT = CFG.cta_text || 'Claim up to 50% off';
var LOGO_SRC = CFG.logo_src || '';
var LOGO_LIGHT_SRC = CFG.logo_light_src || LOGO_SRC; /* for dark loading screen */
var PRODUCT_IMG_SRC = CFG.product_img_src || '';
var PRODUCT_IMG_ALT = CFG.product_img_alt || 'PDRN Micro-Infusion Skin Booster';
var DQ_URL = CFG.dq_url || '/';
/* Before/after images by gender_tone key */
var BA_IMGS = CFG.ba_images || {};
var BA_DEFAULT = CFG.ba_default || '';
var BA_FALLBACK_GENDER = 'male';
/* Proof images */
var PROOF_IMG = CFG.proof_img || '';
/* Quiz steps — can be overridden from Liquid via CFG.steps,
but we include full defaults here for safety */
var STEPS = CFG.steps || getDefaultSteps();
/* ----------------------------------------------------------
STATE
---------------------------------------------------------- */
var answers = {};
var stepIndex = 0;
var calloutTimer = null;
/* scar reference photos — merchant uploads via settings */
var SCAR_IMGS = CFG.scar_imgs || {};
/* ----------------------------------------------------------
ICONS (inline SVG, no external dependency)
---------------------------------------------------------- */
var ICONS = {
drop: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M12 3.5s6 6.6 6 10.6a6 6 0 11-12 0c0-4 6-10.6 6-10.6z" stroke="#0F1F3D" stroke-width="1.7" stroke-linejoin="round"/></svg>',
cactus: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M10 21V6a2 2 0 114 0v15M10 13H8a2 2 0 01-2-2V9M14 15h2a2 2 0 002-2v-2M7 21h10" stroke="#0F1F3D" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
mixed: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M8 19v-9a1.6 1.6 0 113.2 0v9M8 14H6.6A1.6 1.6 0 015 12.4v-1.4" stroke="#0F1F3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M17 11s3 3.4 3 5.4a3 3 0 11-6 0c0-2 3-5.4 3-5.4z" stroke="#0F1F3D" stroke-width="1.5" stroke-linejoin="round"/><path d="M4 20L20 4" stroke="#0F1F3D" stroke-width="1.5" stroke-linecap="round"/></svg>',
scales: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M12 4v16M7 20h10M12 6l-5 2m5-2l5 2" stroke="#0F1F3D" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><path d="M7 8l-2.6 5a2.8 2.8 0 005.2 0L7 8zM17 8l-2.6 5a2.8 2.8 0 005.2 0L17 8z" stroke="#0F1F3D" stroke-width="1.6" stroke-linejoin="round"/></svg>',
leaf: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><path d="M5 19C5 9 12 5 20 5c0 8-4 15-14 15" stroke="#0F1F3D" stroke-width="1.7" stroke-linejoin="round"/><path d="M5 19c3-5 7-8 11-10" stroke="#0F1F3D" stroke-width="1.7" stroke-linecap="round"/></svg>',
question: '<svg width="26" height="26" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5" stroke="#0F1F3D" stroke-width="1.7"/><path d="M9.6 9.5a2.5 2.5 0 114 2c-.9.7-1.6 1.2-1.6 2.3" stroke="#0F1F3D" stroke-width="1.7" stroke-linecap="round"/><circle cx="12" cy="16.7" r="1" fill="#0F1F3D"/></svg>'
};
/* ----------------------------------------------------------
NAVIGATION
---------------------------------------------------------- */
function show(screenId) {
  document.querySelectorAll('.screen').forEach(function (s) {
    s.classList.remove('active');
    s.style.display = 'none';
    s.setAttribute('aria-hidden', 'true');
  });

  var el = document.getElementById(screenId);

  if (el) {
    el.classList.add('active');
    el.style.display = 'block';
    el.removeAttribute('aria-hidden');
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
}

function startQuiz() { stepIndex = 0; renderStep(); show('screen-quiz'); }
function restartQuiz() {
Object.keys(answers).forEach(function (k) { delete answers[k]; });
stepIndex = 0; renderStep(); show('screen-quiz');
}
function goBack() {
if (stepIndex === 0) { show('screen-landing'); return; }
stepIndex--; renderStep();
}
function nextStep() {
if (stepIndex < STEPS.length - 1) { stepIndex++; renderStep(); }
else { finishQuiz(); }
}
/* ----------------------------------------------------------
PROGRESS BAR
---------------------------------------------------------- */
function renderProgress() {
var wrap = document.getElementById('segments');
if (!wrap) return;
wrap.innerHTML = '';
for (var i = 0; i < STEPS.length; i++) {
var seg = document.createElement('i');
seg.className = 'seg' + (i <= stepIndex ? ' on' : '');
wrap.appendChild(seg);
}
var sc = document.getElementById('stepCount');
if (sc) sc.textContent = (stepIndex + 1) + ' / ' + STEPS.length;
}
/* ----------------------------------------------------------
STEP RENDERER
---------------------------------------------------------- */
function renderStep() {
renderProgress();
var step = STEPS[stepIndex];
var card = document.getElementById('qcard');
if (!card) return;
var left = '<h2 class="qtitle">' + step.title + '</h2>';
if (step.help) left += '<p class="qhelp">' + step.help + '</p>';
if (step.callout) {
left += '<div class="callout">' +
'<h4><svg width="17" height="17" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" stroke="#0F1F3D" stroke-width="1.8"/><path d="M12 11v5" stroke="#0F1F3D" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="8" r="1.1" fill="#0F1F3D"/></svg>' +
step.callout.h + '</h4><p>' + step.callout.p + '</p></div>';
}
var right = '';
if (step.type === 'single') {
right += '<div class="options ' + (step.grid || '') + '">';
step.options.forEach(function (o) {
var sel = answers[step.id] === o ? ' selected' : '';
right += '<button class="opt' + sel + '" data-value="' + esc(o) + '" onclick="ElixaQuiz.pickSingle(this)">' + esc(o) + '</button>';
});
right += '</div>';
if (step.writeIn) {
var visible = answers[step.id] === step.writeIn;
right += '<div class="write-in" id="writeIn" style="display:' + (visible ? 'block' : 'none') + '">' +
'<input type="text" id="writeInInput" placeholder="' + esc(step.writeInPlaceholder || '') + '" maxlength="200" value="' + esc(answers[step.id + 'Other'] || '') + '" oninput="ElixaQuiz.saveWriteIn()"></div>';
}
}
if (step.type === 'tiles') {
right += '<div class="tile-grid ' + (step.cols || 'cols-3') + '">';
step.options.forEach(function (o) {
var sel = answers[step.id] === o.label ? ' selected' : '';
var visual = o.swatch
? '<span class="swatch" style="background:' + o.swatch + '"></span>'
: '<span class="ic">' + (ICONS[o.icon] || '') + '</span>';
right += '<button class="tile' + sel + '" data-value="' + esc(o.label) + '" onclick="ElixaQuiz.pickSingle(this)">' +
visual + '<span>' + esc(o.label) + '</span></button>';
});
right += '</div>';
}
if (step.type === 'imageMulti') {
var chosen = answers[step.id] || [];
right += '<div class="img-grid">';
step.options.forEach(function (o) {
var sel = chosen.indexOf(o.label) !== -1 ? ' selected' : '';
var visual = o.img && SCAR_IMGS[o.img]
? '<span class="img-ph" style="background-image:url(' + SCAR_IMGS[o.img] + ')"></span>'
: '<span class="img-ph img-ph-icon">' + (ICONS[o.icon] || ICONS.question) + '</span>';
right += '<button class="img-tile' + sel + '" data-value="' + esc(o.label) + '" onclick="ElixaQuiz.pickMulti(this)">' +
visual +
'<span class="img-check"><svg width="13" height="13" viewBox="0 0 20 20" fill="none"><path d="M4 10.5l4 4L16 6" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
'<span class="img-lab">' + esc(o.label) + '</span>' +
'<span class="img-sub">' + esc(o.sub || '') + '</span>' +
'</button>';
});
right += '</div>';
}
if (step.type === 'multi') {
var chosen2 = answers[step.id] || [];
right += '<div class="options">';
step.options.forEach(function (o) {
var sel = chosen2.indexOf(o) !== -1 ? ' selected' : '';
right += '<button class="check-row' + sel + '" data-value="' + esc(o) + '" onclick="ElixaQuiz.pickMulti(this)">' +
'<span class="check-box"><svg width="13" height="13" viewBox="0 0 20 20" fill="none"><path d="M4 10.5l4 4L16 6" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
'<span>' + esc(o) + '</span></button>';
});
right += '</div>';
}
if (step.type === 'multi' || step.type === 'imageMulti') {
if (step.writeIn) {
var chArr = answers[step.id] || [];
var viW = chArr.indexOf(step.writeIn) !== -1;
right += '<div class="write-in" id="writeIn" style="display:' + (viW ? 'block' : 'none') + '">' +
'<input type="text" id="writeInInput" placeholder="' + esc(step.writeInPlaceholder || '') + '" maxlength="200" value="' + esc(answers[step.id + 'Other'] || '') + '" oninput="ElixaQuiz.saveWriteIn()"></div>';
}
}
if (step.type === 'email') {
right += '<div class="field-stack"><div class="field"><label for="f-email">Email address</label>' +
'<input id="f-email" type="email" inputmode="email" autocomplete="email" placeholder="you@example.com" value="' + esc(answers.email || '') + '" oninput="ElixaQuiz.validateFields()"></div></div>' +
'<p class="field-error" id="emailErr">Please enter a valid email address.</p>' +
'<div class="privacy-note"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="5" y="10" width="14" height="10" rx="2" stroke="#0F1F3D" stroke-width="1.8" opacity=".6"/><path d="M8 10V7a4 4 0 018 0v3" stroke="#0F1F3D" stroke-width="1.8" opacity=".6"/></svg>We respect your privacy. No spam, ever.</div>';
}
if (step.type === 'name') {
right += '<div class="field-stack">' +
'<div class="field"><label class="sr-only" for="f-first">First name</label>' +
'<input id="f-first" type="text" autocomplete="given-name" placeholder="First name" value="' + esc(answers.firstName || '') + '" oninput="ElixaQuiz.validateFields()"></div>' +
'<div class="field"><label class="sr-only" for="f-last">Last name</label>' +
'<input id="f-last" type="text" autocomplete="family-name" placeholder="Last name" value="' + esc(answers.lastName || '') + '" oninput="ElixaQuiz.validateFields()"></div>' +
'</div><p class="field-error" id="nameErr">Please enter both your first and last name.</p>';
}
var isLast = stepIndex === STEPS.length - 1;
var lastLabel = step.type === 'name' ? 'See My Results' : 'Continue';
var hasAnswer = (step.type === 'multi' || step.type === 'imageMulti')
? !!(answers[step.id] && answers[step.id].length)
: !!answers[step.id];
var dis = hasAnswer || step.type === 'email' || step.type === 'name' ? '' : 'disabled';
right += '<div class="continue-wrap"><button class="btn" id="continueBtn" onclick="ElixaQuiz.tryContinue()" ' + dis + '>' + lastLabel + '</button></div>';
right += '<button class="ghost-link" onclick="ElixaQuiz.goBack()">Go back</button>';
card.innerHTML = '<div class="q-left">' + left + '</div><div class="q-right">' + right + '</div>';
if (step.type === 'email' || step.type === 'name') validateFields();
clearTimeout(calloutTimer);
var co = card.querySelector('.callout');
if (co) {
calloutTimer = setTimeout(function () { co.classList.add('reveal'); }, 1500);
}
}
/* ----------------------------------------------------------
ANSWER HANDLING
---------------------------------------------------------- */
function pickSingle(btn) {
var step = STEPS[stepIndex];
btn.closest('.q-right').querySelectorAll('.selected').forEach(function (el) { el.classList.remove('selected'); });
btn.classList.add('selected');
answers[step.id] = btn.dataset.value;
var cb = document.getElementById('continueBtn');
if (cb) cb.disabled = false;
if (step.writeIn && btn.dataset.value === step.writeIn) {
var w = document.getElementById('writeIn');
if (w) { w.style.display = 'block'; var wi = document.getElementById('writeInInput'); if (wi) wi.focus(); }
return;
}
var w2 = document.getElementById('writeIn');
if (w2) w2.style.display = 'none';
}
function pickMulti(btn) {
var step = STEPS[stepIndex];
var val = btn.dataset.value;
var chosen = answers[step.id] || [];
if (val === step.exclusive) {
chosen = chosen.indexOf(val) !== -1 ? [] : [val];
} else {
chosen = chosen.filter(function (v) { return v !== step.exclusive; });
chosen = chosen.indexOf(val) !== -1
? chosen.filter(function (v) { return v !== val; })
: chosen.concat([val]);
}
answers[step.id] = chosen;
btn.closest('.q-right').querySelectorAll('[data-value]').forEach(function (el) {
el.classList.toggle('selected', chosen.indexOf(el.dataset.value) !== -1);
});
if (step.writeIn) {
var w = document.getElementById('writeIn');
if (w) w.style.display = chosen.indexOf(step.writeIn) !== -1 ? 'block' : 'none';
}
var cb = document.getElementById('continueBtn');
if (cb) cb.disabled = !chosen.length;
}
function saveWriteIn() {
var step = STEPS[stepIndex];
var inp = document.getElementById('writeInInput');
if (inp) answers[step.id + 'Other'] = inp.value.trim();
}
function validateFields() {
var step = STEPS[stepIndex];
var btn = document.getElementById('continueBtn');
if (!btn) return;
if (step.type === 'email') {
var v = (document.getElementById('f-email') || {}).value || '';
answers.email = v.trim();
btn.disabled = !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim());
var ee = document.getElementById('emailErr');
if (ee) ee.classList.remove('show');
var fi = document.getElementById('f-email');
if (fi) fi.classList.remove('err');
}
if (step.type === 'name') {
var f = (document.getElementById('f-first') || {}).value || '';
var l = (document.getElementById('f-last') || {}).value || '';
answers.firstName = f.trim(); answers.lastName = l.trim();
btn.disabled = !(f.trim() && l.trim());
var ne = document.getElementById('nameErr');
if (ne) ne.classList.remove('show');
}
}
function tryContinue() {
var step = STEPS[stepIndex];
if (step.type === 'email') {
var inp = document.getElementById('f-email');
var v = inp ? inp.value.trim() : '';
if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
if (inp) inp.classList.add('err');
var ee = document.getElementById('emailErr');
if (ee) ee.classList.add('show');
return;
}
}
if (step.type === 'name') {
if (!(answers.firstName && answers.lastName)) {
var ne = document.getElementById('nameErr');
if (ne) ne.classList.add('show');
return;
}
}
nextStep();
}
/* ----------------------------------------------------------
FINISH → LOADING → RESULTS
---------------------------------------------------------- */
function finishQuiz() {
submitLead(answers);
var conditions = answers.conditions || [];
if (conditions.indexOf('Currently pregnant or breastfeeding') !== -1) {
show('screen-dq');
return;
}
show('screen-loading');
setTimeout(function () {
populateResults();
show('screen-results');
startReserveTimer();
}, LOADING_MS + 300);
}
/* ----------------------------------------------------------
RESULTS POPULATION
---------------------------------------------------------- */
var SCAR_SHORT = {
'Ice pick scars': 'ice pick scars',
'Boxcar scars': 'boxcar scars',
'Rolling scars': 'rolling scars',
'Raised scars': 'raised scars',
'Dark marks': 'dark marks'
};
function skinToneGroup(label) {
var map = {
'Fair / Light':'light',
'Light / Medium':'medium',
'Medium / Tan':'tan',
'Dark':'deep',
'Type I':'light',
'Type II':'medium',
'Type III':'medium',
'Type IV':'tan',
'Type V':'deep',
'Type VI':'deep'
};
return map[label] || 'medium';
}
function genderGroup() {
if (answers.sex === 'Male') return 'male';
if (answers.sex === 'Female') return 'female';
return '';
}
function pickBeforeAfter() {
var g = genderGroup() || BA_FALLBACK_GENDER;
var t = skinToneGroup(answers.skinTone);
return BA_IMGS[g + '_' + t] || BA_IMGS[BA_FALLBACK_GENDER + '_' + t] || BA_DEFAULT || null;
}
function populateResults() {
var scarTypes = (answers.scarTypes || []).filter(function (t) { return t !== "I'm not sure"; });
/* 1. Headline */
var head = document.getElementById('resultsHeadline');
if (head) {
var useName = USE_FIRST_NAME && answers.firstName && answers.firstName.trim();
head.textContent = useName
? FALLBACK_HEADLINE.replace('Your results are in', 'Your results are in') + ', ' + answers.firstName
: FALLBACK_HEADLINE;
/* Simple: */
head.textContent = (useName ? 'Your results are in, ' + answers.firstName : FALLBACK_HEADLINE);
}
/* 2. Logo */
var srcLogo = document.getElementById('elixaLogoSrc');
var dstLogo = document.getElementById('resultsLogo');
if (srcLogo && dstLogo && srcLogo.src) dstLogo.src = srcLogo.src;
/* 3. Offer line */
var ol = document.getElementById('tcOfferLine');
if (ol) ol.innerHTML = OFFER_LINE;
/* 4. Product name */
var pn = document.getElementById('tcProductName');
if (pn) pn.textContent = PRODUCT_NAME;
/* 5. Benefit line */
var ben = document.getElementById('tcBenefit');
if (ben) {
if (DYNAMIC_BENEFIT && scarTypes.length) {
ben.textContent = 'For ' + scarTypes.slice(0, 2).map(function (t) { return t.toLowerCase(); }).join(' & ') + ' and uneven texture';
} else {
ben.textContent = BENEFIT_LINE;
}
}
/* 6. Product image */
var pi = document.getElementById('tcProductImg');
if (pi && PRODUCT_IMG_SRC) {
pi.src = PRODUCT_IMG_SRC;
pi.alt = PRODUCT_IMG_ALT;
pi.style.display = '';
}
/* 7. Profile summary */
var durMap = { 'Less than 1 year':'< 1 year', '1-3 years':'1–3 years', '3-10 years':'3–10 years', '10+ years':'10+ years' };
var toneMap = {
'Fair / Light':'Fair / Light',
'Light / Medium':'Light / Medium',
'Medium / Tan':'Medium / Tan',
'Dark':'Dark',
'Type I':'Fair / Light',
'Type II':'Light / Medium',
'Type III':'Light / Medium',
'Type IV':'Medium / Tan',
'Type V':'Dark',
'Type VI':'Dark'
};
var scarLabel = scarTypes.length ? scarTypes.slice(0,2).join(' & ') : 'Acne scars';
var profileItems = [
['Main concern', scarLabel + ' and uneven texture'],
['Scar type', scarTypes.length ? scarTypes.slice(0,2).join(' & ') : '—'],
['Scar duration', durMap[answers.scarDuration] || (answers.scarDuration || '—')],
['Skin tone', toneMap[answers.skinTone] || (answers.skinTone || '—')],
['Recommended treatment', PRODUCT_NAME]
];
var list = document.getElementById('profileSummaryList');
if (list) {
list.innerHTML = profileItems.map(function (p) {
return '<li><span class="p-label">' + p[0] + '</span><span class="p-val">' + p[1] + '</span></li>';
}).join('');
}
/* 8. Before/after image */
var baUrl = pickBeforeAfter();
['resultBaImg','resultBaImgDesktop'].forEach(function (id) {
var img = document.getElementById(id);
if (!img) return;
if (baUrl) { img.src = baUrl; img.style.display = ''; }
else { img.style.display = 'none'; }
});
/* 9. Proof strip */
var proofCopy = document.getElementById('proofCopy');
var proofCopyD = document.getElementById('proofCopyDesktop');
if (proofCopy) proofCopy.innerHTML = PROOF_COPY;
if (proofCopyD) proofCopyD.innerHTML = PROOF_COPY;
if (PROOF_IMG) {
['proofImgStrip','proofImgStripDesktop'].forEach(function (id) {
var img = document.getElementById(id);
if (img) { img.src = PROOF_IMG; img.style.display = ''; }
});
}
if (!SHOW_PROOF) {
['tcProofBlock','leftProofDesktop'].forEach(function (id) {
var el = document.getElementById(id);
if (el) el.style.display = 'none';
});
}
/* 10. CTA */
var ctaEl = document.getElementById('offerCta');
if (ctaEl) {
ctaEl.textContent = CTA_TEXT;
var href = CTA_URL;
if (APPEND_PARAMS) {
var params = new URLSearchParams();
if (answers.skinTone) params.set('skin_tone', answers.skinTone);
if (answers.sex) params.set('gender_group', answers.sex);
if (answers.scarDuration) params.set('scar_duration',answers.scarDuration);
var scarStr = scarTypes.slice(0,2).join(',');
if (scarStr) params.set('scar_type', scarStr);
params.set('result_profile','pdrn-micro-infusion');
href = CTA_URL + '?' + params.toString();
}
ctaEl.href = href;
if (CTA_SAME_TAB) ctaEl.removeAttribute('target');
else ctaEl.target = '_blank';
}
}
/* ----------------------------------------------------------
TIMER
---------------------------------------------------------- */
function startReserveTimer() {
var reserveEl = document.getElementById('reserveBlock');
if (!SHOW_TIMER) {
if (reserveEl) reserveEl.style.display = 'none';
return;
}
var labelEl = document.getElementById('timerLabel');
if (labelEl) labelEl.textContent = TIMER_LABEL;
var secs = (TIMER_MINUTES * 60) + TIMER_SECONDS;
var el = document.getElementById('timer');
function fmt(s) {
return '00 : ' + String(Math.floor(s/60)).padStart(2,'0') + ' : ' + String(s%60).padStart(2,'0');
}
if (el) el.textContent = fmt(secs);
var tick = setInterval(function () {
secs--;
if (secs <= 0) { clearInterval(tick); if (el) el.textContent = '00 : 00 : 00'; return; }
if (el) el.textContent = fmt(secs);
}, 1000);
}
/* ----------------------------------------------------------
ACCORDION
---------------------------------------------------------- */
function toggleAcc(btn) {
if (!btn) return;
var acc = btn.closest ? btn.closest('.acc') : btn.parentElement;
if (acc) acc.classList.toggle('open');
}
/* Bind accordions via event delegation — no inline onclick needed */
document.addEventListener('click', function (e) {
var btn = e.target.closest('.acc-head');
if (btn) toggleAcc(btn);
});
/* ----------------------------------------------------------
PROFILE TAB
---------------------------------------------------------- */
function toggleProfileTab() {
var tab = document.getElementById('profileTab');
var btn = document.getElementById('profileTabBtn');
if (!tab) return;
var isOpen = tab.classList.toggle('open');
if (btn) btn.setAttribute('aria-expanded', isOpen);
}
/* ----------------------------------------------------------
LEAD CAPTURE
---------------------------------------------------------- */
function submitLead(data) {
var payload = {
timestamp: new Date().toISOString(),
source: 'elixa-skincare-quiz',
firstName: data.firstName || '',
lastName: data.lastName || '',
email: data.email || '',
age: data.age || '',
scarDuration: data.scarDuration || '',
scarTypes: (data.scarTypes || []).join(', '),
bothersMost: data.bothers || '',
bothersOther: data.bothersOther || '',
skinTone: data.skinTone || '',
skinType: data.skinType || '',
treatmentsTried: (data.treatments || []).join(', '),
treatmentsOther: data.treatmentsOther || '',
usingActives: data.actives || '',
conditions: (data.conditions || []).join(', '),
pageUrl: location.href,
userAgent: navigator.userAgent,
sexAtBirth: data.sex || ''
};
console.log('[ELIXA QUIZ] lead captured:', payload);
if (!WEBHOOK_URL) {
console.warn('[ELIXA QUIZ] WEBHOOK_URL not set. Lead logged to console only.');
return;
}
fetch(WEBHOOK_URL, {
method: 'POST',
mode: 'no-cors',
headers: { 'Content-Type': 'text/plain;charset=utf-8' },
body: JSON.stringify(payload)
}).catch(function (err) { console.warn('[ELIXA QUIZ] webhook failed:', err); });
}
/* ----------------------------------------------------------
HELPER
---------------------------------------------------------- */
function esc(str) {
return String(str)
.replace(/&/g,'&amp;')
.replace(/</g,'&lt;')
.replace(/>/g,'&gt;')
.replace(/"/g,'&quot;')
.replace(/'/g,'&#39;');
}
/* ----------------------------------------------------------
DEFAULT QUIZ STEPS
Merchants can override via CFG.steps from the Liquid section.
---------------------------------------------------------- */
function getDefaultSteps() {
return [
{
id: 'age', type: 'single', grid: 'grid-2',
title: 'What is your age?',
help: 'This helps us personalize your treatment plan. We keep this information private.',
options: ['55+', '45-54', '35-44', '25-34', '18-24'],
callout: { h: 'Did you know?', p: "Your skin's repair process changes over time. Understanding your age helps us tailor your recommendation to your skin's current stage." }
},
{
id: 'sex', type: 'single', grid: '',
title: 'What was your sex at birth?',
options: ['Male', 'Female', 'Prefer not to say'],

},
{
id: 'scarDuration', type: 'single', grid: 'grid-2',
title: 'How long have you had your acne scars?',
help: 'Old scars are not a problem. Skin keeps remodeling for decades.',
options: ['10+ years', '3-10 years', '1-3 years', 'Less than 1 year'],
callout: { h: 'Did you know?', p: 'Older scars can still respond to the right treatment approach. The age of your scars helps us understand how much repair support your skin may need.' }
},
{
id: 'scarTypes', type: 'imageMulti',
title: 'What type of acne scars do you have?',
help: 'Select all that apply. Most people have more than one type.',
options: [
{ label: 'Ice pick scars', sub: 'Deep, narrow pits', img: 'icepick' },
{ label: 'Boxcar scars', sub: 'Wide dents with sharp edges', img: 'boxcar' },
{ label: 'Rolling scars', sub: 'Wavy, uneven texture', img: 'rolling' },
{ label: 'Raised scars', sub: 'Thick, raised bumps', img: 'raised' },
{ label: 'Dark marks', sub: 'Spots left after breakouts', img: 'darkspots' },
{ label: "I'm not sure", sub: 'Skip this one', icon: 'question' }
],
exclusive: "I'm not sure",
callout: { h: 'Why this matters', p: 'Different scar types form in different ways. Identifying your scar pattern helps us understand what your skin needs most — whether that is texture support, repair support, or tone correction.' }
},
{
id: 'bothers', type: 'single', grid: '',
title: 'What bothers you most about your scars?',
options: [
'How they look in photos and on video calls',
'Dating and first impressions',
'Confidence at work and socially',
'The rough texture I see and feel every day',
'Something else'
],
writeIn: 'Something else',
writeInPlaceholder: 'Tell us in your own words (optional)',
callout: { h: 'You are not alone', p: 'For many people, acne scars affect more than just skin texture. This helps us understand what outcome matters most to you personally.' }
},
{
id: 'skinTone', type: 'tiles', cols: 'cols-2',
title: 'Which best describes your skin tone?',
help: 'Choose the closest match. This helps us show a more relevant before/after example for your skin profile.',
options: [
{ label: 'Fair / Light', swatch: '#FBE9DD' },
{ label: 'Light / Medium', swatch: '#E7B98F' },
{ label: 'Medium / Tan', swatch: '#B9784B' },
{ label: 'Dark', swatch: '#5B3424' }
],

},
{
id: 'skinType', type: 'tiles', cols: 'cols-3',
title: 'Which best describes your skin?',
options: [
{ label: 'Oily', icon: 'drop' },
{ label: 'Dry', icon: 'cactus' },
{ label: 'Combination', icon: 'mixed' },
{ label: 'Sensitive', icon: 'leaf' },
{ label: 'Normal', icon: 'scales' },
{ label: 'Not sure', icon: 'question' }
],

},
{
id: 'treatments', type: 'multi',
title: 'What have you already tried for your scars?',
help: 'Select all that apply.',
options: [
'Nothing yet',
'Retinol or prescription creams',
'Chemical peels',
'Microneedling (in clinic or at home)',
'Laser treatments',
'Other'
],
exclusive: 'Nothing yet',
writeIn: 'Other',
writeInPlaceholder: 'What else have you tried? (optional)',

},
{
id: 'actives', type: 'single', grid: '',
title: 'Are you currently using any active skincare ingredients?',
help: 'For example: retinol, tretinoin, exfoliating acids, or vitamin C.',
options: ['Yes', 'No'],
callout: { h: 'Why we ask', p: 'Certain active ingredients can affect skin sensitivity. Knowing what you currently use helps us make a safer and more relevant recommendation.' }
},
{
id: 'conditions', type: 'multi',
title: 'Do any of the following apply to you?',
help: 'Select all that apply. This is only used to check the treatment is right for you.',
options: [
'None of the below',
'Currently pregnant or breastfeeding',
'History of skin cancer or melanoma',
'Active eczema, psoriasis, or rosacea',
'Allergies to tretinoin, hydroquinone, or minoxidil',
'Currently taking isotretinoin (Accutane)'
],
exclusive: 'None of the below',
callout: { h: 'Your safety comes first', p: 'Some skin or health conditions may affect whether a treatment is suitable. This step helps us make sure the recommendation is appropriate for you.' }
},
{
id: 'email', type: 'email',
title: 'Where can we send a copy of your results?',
help: 'You will get your personalized treatment plan plus your quiz only discount.',

},
{
id: 'name', type: 'name',
title: 'Almost done! What is your first and last name?',

}
];
}
/* ----------------------------------------------------------
PUBLIC API — expose on window so inline onclick= still works
---------------------------------------------------------- */
window.ElixaQuiz = {
startQuiz: startQuiz,
restartQuiz: restartQuiz,
goBack: goBack,
tryContinue: tryContinue,
pickSingle: pickSingle,
pickMulti: pickMulti,
saveWriteIn: saveWriteIn,
validateFields: validateFields,
toggleProfileTab: toggleProfileTab,
toggleAcc: toggleAcc
};
/* Also expose at top level for legacy onclick= attributes */
window.startQuiz = startQuiz;
window.restartQuiz = restartQuiz;
window.goBack = goBack;
window.tryContinue = tryContinue;
window.pickSingle = pickSingle;
window.pickMulti = pickMulti;
window.saveWriteIn = saveWriteIn;
window.validateFields = validateFields;
window.toggleProfileTab = toggleProfileTab;
window.toggleAcc = toggleAcc;
/* ----------------------------------------------------------
INIT — wait for DOM
---------------------------------------------------------- */
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
function init() {
/* Nothing to pre-init; quiz starts on button click */
/* Accordion binding is done via event delegation above */
}
})();
